import { GetBannersArgs } from 'types/api/arguments/get-banners-args'
import { BannersResp } from 'types/api/response/banners-resp'

import { api } from './api'

export const noCacheHeader = {
  'Cache-Control': 'no-cache',
}

export const getBanners = ({ disableCache = false }: GetBannersArgs = {}) =>
  api.get<BannersResp>('/banners', {
    headers: disableCache ? noCacheHeader : {},
  })
